import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Divider,
  Button,
  Chip,
  Paper,
  IconButton, // تأكد من استيراد IconButton
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DateRangeIcon from "@mui/icons-material/DateRange";
import ClassIcon from "@mui/icons-material/Class";
import AddCommentIcon from "@mui/icons-material/AddComment";
import SubjectIcon from "@mui/icons-material/Subject";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"; // الأيقونة هنا
import { RATING_OPTIONS } from "./ratingOptions";
import { VList } from "../utils/layouts";

const AssessmentCard = ({ item, description, onOpenDialog, onDelete }) => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString("ar-EG", options);
  };

  const getRatingDetails = (levelValue) => {
    const numValue = Number(levelValue);
    return RATING_OPTIONS.find((opt) => opt.value === numValue) || null;
  };

  const ratingData = getRatingDetails(item.level);
  const RatingIcon = ratingData?.icon;

  const rawDescription = description !== undefined ? description : item.result;
  const isDescriptionSameAsLevel = String(rawDescription) === String(item.level);
  const finalDescription = isDescriptionSameAsLevel ? "" : rawDescription;
  const hasDescription = finalDescription && String(finalDescription).trim() !== "";

  const handleDeleteClick = () => setOpenDeleteDialog(true);
  const handleCloseDialog = () => setOpenDeleteDialog(false);
  const handleConfirmDelete = () => {
    if (onDelete) onDelete(item.id);
    setOpenDeleteDialog(false);
  };

  return (
    <>
      <Paper variant="section" sx={{maxWidth:'290px'
      }}>
        
        <VList>
          {/* تم تحديث هذا الـ Box لضمان ظهور الأيقونة */}
          <Box 
            sx={{ 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "space-between", // يضع الاسم يميناً والأيقونة يساراً
              width: "100%", // مهم جداً لأخذ العرض كاملاً
              mb: 1 
            }}
          >
            {/* قسم الصورة والاسم */}
            <Box sx={{ display: "flex", alignItems: "center", overflow: "hidden" }}>
              <Avatar sx={{ bgcolor: "primary.light", ml: 1, width: 32, height: 32 }}>
                <PersonIcon fontSize="small" />
              </Avatar>
              <Typography
                noWrap
                variant="subtitle1"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                {item.student?.full_name || "اسم الطالب غير متوفر"}
              </Typography>
            </Box>

            {/* زر الحذف */}
            <IconButton 
              color="error" 
              onClick={handleDeleteClick} 
              size="small" 
              aria-label="delete"
              sx={{ bgcolor: 'error.lighter' }}
            >
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Box>

          <Divider sx={{ mb: 1.5 }} />

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ClassIcon fontSize="small" color="action" />
              <Typography variant="body2" color="text.secondary">
                {item.class?.fullTitle || "الصف غير متوفر"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <MenuBookIcon fontSize="small" color="action" />
              <Typography variant="body2" color="text.secondary">
                {item.course?.title || "المادة غير متوفرة"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <SubjectIcon fontSize="small" color="action" />
              <Typography variant="body2" color="text.secondary">
                {item.lessonTitle || "الدرس غير متوفر"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
              <Typography variant="body2" fontWeight="bold" color="text.primary">
                المحور:
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {item.assessmentCriteria?.title || "غير محدد"}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ mt: "auto", mb: 2 }}>
            {hasDescription ? (
              <Box>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: "bold", mb: 0.5 }}>
                  العبارة الوصفية :
                </Typography>
                <Typography variant="body2" color="text.primary" sx={{ whiteSpace: "pre-wrap" }}>
                  {finalDescription}
                </Typography>
              </Box>
            ) : (
              <Button
                variant="text"
                color="warning"
                size="small"
                fullWidth
                startIcon={<AddCommentIcon sx={{ ml: '10px' }} />}
                onClick={() => onOpenDialog(item.id, item.level)}
              >
                إضافة عبارة وصفية
              </Button>
            )}
          </Box>

          



              

          <Paper
            variant="glass"
            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <DateRangeIcon fontSize="small" color="disabled" />
              <Typography variant="hint">{formatDate(item.date)}</Typography>
            </Box>

            {ratingData ? (
              <Box
                sx={{
                  fontWeight: "bold",
                  color: ratingData.color,
                  borderColor: ratingData.color,
                  borderWidth: 1,
                  p: "2px",
                  borderStyle: "solid",
                  borderRadius: "50%",
                  bgcolor: `${ratingData.color}15`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                {RatingIcon && <RatingIcon style={{ color: ratingData.color, margin: "2px" }} />}
              </Box>
            ) : (
              <Chip variant="outlined" size="small" />
            )}
          </Paper>
        </VList>
      </Paper>

      {/* دايلوج تأكيد الحذف */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDialog} dir="rtl">
        <DialogTitle sx={{ color: 'error.main', fontWeight: 'bold' }}>تأكيد الحذف</DialogTitle>
        <DialogContent>
          <DialogContentText>
            هل أنت متأكد من رغبتك في حذف هذا التقييم؟
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, display: 'flex', gap: 1 }}>
          <Button onClick={handleCloseDialog} color="inherit">
            إلغاء
          </Button>
          <Button onClick={handleConfirmDelete} color="error" variant="contained" disableElevation>
            حذف
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AssessmentCard;